// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ZoneDropSlot_wrapper__ETcli","global-spell":"ZoneDropSlot_global-spell__i3bza","active":"ZoneDropSlot_active__aHszG","button":"ZoneDropSlot_button__m_taF"};